import UIErrorMessage from '$shared/constants/UIErrorMessage';
import { countryData } from '$provider/lib/datas/CountryData';
import type { IProfileMergeRecordAddressModel } from '$provider/lib/apis/interfaces/IProfileMergeRecordAddressModel';
import type { AddressInputFormDataModel } from '$shared/models/forms/AddressInputFormDataModel';

export class AddressValidator {
  static validateProfileMergeAddress(value: IProfileMergeRecordAddressModel): void {
    let isValid = false;

    const isUnitedStateCountry = !value.countryId || countryData.isUSA(value.countryId);
    if (isUnitedStateCountry) {
      isValid = !!(value.addressLine1 && value.city && value.state && value.zipCode);
    } else {
      isValid = !!(value.addressLine1 && value.city && value.countryId);
    }

    if (!isValid) throw new Error(UIErrorMessage.AddressFieldValidationMessage);
  }

  static validateForm(address: AddressInputFormDataModel): void {
    const isUSACountry = countryData.isUSA(address.countryId);
    const isUnitedStateCountry = !address.countryId || isUSACountry;

    let requiredFields = ['addressLine1', 'city', 'state', 'zipCode'];
    if (!isUnitedStateCountry) {
      requiredFields = ['addressLine1', 'city', 'countryId'];
    } else {
      isUSACountry && requiredFields.push('countryId');
    }

    const count = requiredFields.filter(
      (key: string) => address[key as keyof AddressInputFormDataModel]
    ).length;
    if (count === 0) return;

    requiredFields.forEach((key: string) => {
      const typeKey = key as keyof AddressInputFormDataModel;
      if (!address[typeKey]) {
        address.errors[typeKey] = UIErrorMessage.FieldRequired;
        return;
      }
      address.errors[typeKey] && delete address.errors[typeKey];
    });
  }
}
